import React from 'react';
import { motion } from 'framer-motion';
import {
  DocumentTextIcon,
  WrenchScrewdriverIcon,
  BuildingLibraryIcon,
} from '@heroicons/react/24/outline';
import PageHeader from '../ui/PageHeader';
import Button from '../ui/Button';
import { useLanguage } from '../../contexts/LanguageContext';

function ClientEnterpriseHub() {
  const { t } = useLanguage();
  const e = t.enrola;
  const cv = e.corporateView;

  return (
    <div className="space-y-6 xl:space-y-7">
      <PageHeader
        eyebrow="Enrola"
        icon={BuildingLibraryIcon}
        title={e.corporate}
        subtitle={cv.subtitle}
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 sm:gap-6">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="card-premium interactive-lift p-4 sm:p-6"
        >
          <div className="icon-tile mb-4 h-11 w-11 from-orange-500 to-amber-500">
            <DocumentTextIcon className="w-6 h-6 text-white" />
          </div>
          <h3 className="text-lg font-semibold text-secondary-900  mb-2">
            {cv.esignTitle}
          </h3>
          <p className="text-sm text-secondary-600  mb-4">
            {cv.esignExtendedDesc}
          </p>
          <Button variant="secondary" size="compact" className="w-full">
            {cv.openPendingDocs}
          </Button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.05 }}
          className="card-premium interactive-lift p-4 sm:p-6"
        >
          <div className="icon-tile mb-4 h-11 w-11 from-violet-500 to-indigo-500">
            <WrenchScrewdriverIcon className="w-6 h-6 text-white" />
          </div>
          <h3 className="text-lg font-semibold text-secondary-900  mb-2">
            {cv.afterSalesTitle}
          </h3>
          <ul className="text-sm text-secondary-600  space-y-2 list-disc list-inside mb-4">
            <li>{cv.services}</li>
            <li>{cv.maintenance}</li>
            <li>{cv.warranties}</li>
          </ul>
          <Button variant="secondary" size="compact" className="w-full">
            {cv.newRequest}
          </Button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="card-premium interactive-lift p-4 sm:p-6 bg-gradient-to-br from-slate-50 to-white  "
        >
          <div className="icon-tile mb-4 h-11 w-11 from-slate-600 to-slate-800">
            <BuildingLibraryIcon className="w-6 h-6 text-white" />
          </div>
          <h3 className="text-lg font-semibold text-secondary-900  mb-2">
            {cv.elantarOneTitle}
          </h3>
          <p className="text-sm text-secondary-600  mb-4">
            {cv.elantarOneExtendedDesc}
          </p>
          <span className="badge-premium">{cv.syncInDevelopment}</span>
        </motion.div>
      </div>
    </div>
  );
}

export default ClientEnterpriseHub;
